const handlingItemPlaceholder = {
  startContactName: {
    text: "发货联系人",
    type: "input",
    mustFill: true
  },
  startContactPhone: {
    text: "发货联系电话",
    type: "input",
    mustFill: true
  },
  startPoint: {
    text: "发货点",
    type: "select",
    mustFill: true
  },
  expectDeliveryTime: {
    text: "发货时间",
    type: "select"
  },
  endContactName: {
    text: "到货联系人",
    type: "input",
    mustFill: true
  },
  endContactPhone: {
    text: "到货联系电话",
    type: "input",
    mustFill: true
  },
  endPoint: {
    text: "到货点",
    type: "select",
    mustFill: true
  },
  expectArrivalTime: {
    text: "到货时间",
    type: "select"
  }
};

const goodsItemPlaceholder = {
  goodsCategoryid: {
    text: "货物",
    type: "select",
    mustFill: true
  },
  goodsWeight: {
    text: "重量",
    type: "input",
    mustFill: true
  },
  goodsNumber: {
    text: "件数",
    type: "input"
  }
};

const getInputText = key => {
  let { text, type, mustFill } = {
    ...handlingItemPlaceholder,
    ...goodsItemPlaceholder
  }[key];
  return `${type === "input" ? "请输入" : "请选择"}${text}${
    mustFill ? "" : "(选填)"
  }`;
};

export { handlingItemPlaceholder, goodsItemPlaceholder, getInputText };



// WEBPACK FOOTER //
// ./src/views/personal/deliver/components/handlingWrapper/config/index.js